let closePopupFn = () => {
  console.error('Popup close function not set');
};

const setPopupClose = (fn) => {
  closePopupFn = fn;
};

const closePopup = () => {
  closePopupFn();
};

export { setPopupClose, closePopup };
